import React, { useState } from 'react';
// import ReCAPTCHA from "react-google-recaptcha";
import { ChevronRight, Mail, Phone, MapPin } from 'lucide-react';
import SocialMediaCTA from '../components/SocialMediaCTA';
import NewsSection from '../components/landingPage/NewsSection';

const ContactUsPage = () => {
  const [activeLocation, setActiveLocation] = useState('malaysia');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  // const [recaptchaToken, setRecaptchaToken] = useState(null);

  const locations = [
    { id: 'malaysia', name: 'MK Metal Malaysia (HQ)' },
    // { id: 'singapore', name: 'MK Metal Singapore' },
    // { id: 'indonesia', name: 'MK Metal Indonesia' },
  ];

  const contactDetails = {
    malaysia: {
      title: 'MK METAL & ENGINEERING WORKS SDN.BHD',
      address: ' NO. 16-1 (1ST FLOOR), JALAN BALAKONG JAYA 6, TAMAN BALAKONG JAYA, 43200 BALAKONG, SELANGOR DARUL EHSAN.',
      email: 'mkmetal1112@gmail.com',
      phone1: '+60 12 298 6592',
      phone2: '+60 16 645 5309',
      phone3: '+60 16 916 7740',
      mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.3321077350793!2d101.7369836!3d3.0050185999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cdcb1ff730adf7%3A0xd7a6b7598921791b!2sMK%20METAL%20%26%20ENGINEERING%20WORKS%20SDN.%20BHD.!5e0!3m2!1sen!2sbd!4v1762611963171!5m2!1sen!2sbd', // Placeholder
    }
    // ,
    // singapore: {
    //   title: 'MK METAL SINGAPORE OFFICE',
    //   address: '10 Anson Road, #27-15 International Plaza, Singapore 079903',
    //   email: 'sg@mkmetal.com',
    //   phone1: '+65 6123 4567',
    //   mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8000000000003!2d103.84700000000001!3d1.2790000000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190000000001%3A0x0!2zMTHCMjcnMTQuNCJOIDEwM8KwNTAnNTYuNCJF!5e0!3m2!1sen!2smy!4v1678912345678!5m2!1sen!2smy', // Placeholder
    // },
    // indonesia: {
    //   title: 'MK METAL INDONESIA OFFICE',
    //   address: 'Jl. Jend. Sudirman No.Kav 52-53, Jakarta, Indonesia',
    //   email: 'id@mkmetal.com',
    //   phone1: '+62 21 1234 5678',
    //   mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.3000000000003!2d106.81000000000001!3d-6.2080000000000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f50000000001%3A0x0!2zNsKwMTInMjguOCJTIDEwNsKwNDgnMzYuMCJF!5e0!3m2!1sen!2smy!4v1678912345678!5m2!1sen!2smy', // Placeholder
    // },
  };

  const currentDetails = contactDetails[activeLocation];

  const validate = () => {
    let tempErrors = {};
    if (!formData.name) tempErrors.name = "Name is required";
    if (!formData.email) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Email is not valid";
    }
    if (!formData.message) tempErrors.message = "Message is required";
    // if (!recaptchaToken) tempErrors.recaptcha = "Please verify that you are not a robot";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/contacts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...formData }),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', telephone: '', message: '' });
      } else {
        const data = await response.json();
        if (data.errors) {
          setErrors(data.errors.reduce((acc, error) => ({ ...acc, [error.param]: error.msg }), {}));
        }
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }

    setIsSubmitting(false);
  };

  return (
    <div className="bg-[#020d38] py-16 px-4">
      {/* Section-01: Image & Contact Form */}
    <section className="bg-white py-20 px-4">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-main-blue text-center mb-8 sm:mb-12">
         Contact Us
        </h1>
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left Column: Visual Impact */}
        <div className="md:col-span-1">
          <img
            src="/hero_img/image-06.jpg" // Placeholder image
            alt="Contact Us"
            className="w-full h-full object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Right Column: Contact Form */}
        <div className="md:col-span-1">
          <h2 className="text-4xl font-bold text-[#364A9A] mb-8 font-poppins">
            Send us a message for more information
          </h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="sr-only">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleInputChange}
                className="w-full px-0 py-2 border-b-2 border-gray-300 focus:outline-none focus:border-[#364A9A] text-gray-700 font-serif"
              />
              {errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
            </div>
            <div>
              <label htmlFor="email" className="sr-only">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full px-0 py-2 border-b-2 border-gray-300 focus:outline-none focus:border-[#364A9A] text-gray-700 font-serif"
              />
              {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
            </div>
            <div>
              <label htmlFor="telephone" className="sr-only">Telephone</label>
              <input
                type="tel"
                id="telephone"
                name="telephone"
                placeholder="Telephone"
                value={formData.telephone}
                onChange={handleInputChange}
                className="w-full px-0 py-2 border-b-2 border-gray-300 focus:outline-none focus:border-[#364A9A] text-gray-700 font-serif"
              />
            </div>
            <div>
              <label htmlFor="message" className="sr-only">Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                placeholder="Message"
                value={formData.message}
                onChange={handleInputChange}
                className="w-full px-0 py-2 border-b-2 border-gray-300 focus:outline-none focus:border-[#364A9A] text-gray-700 font-serif resize-none"
              ></textarea>
              {errors.message && <p className="text-red-500 text-xs">{errors.message}</p>}
            </div>
            
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-[#364A9A] text-[#ffffff] font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105 font-poppins"
            >
              {isSubmitting ? 'SENDING...' : 'SEND INQUIRY'}
            </button>
            {submitStatus === 'success' && (
              <p className="text-green-600">Your message has been sent successfully!</p>
            )}
            {submitStatus === 'error' && (
              <p className="text-red-600">There was an error sending your message. Please try again later.</p>
            )}
          </form>
        </div>
      </div>
    </section>
      <div className="container pt-20 mx-auto grid grid-cols-1 lg:grid-cols-3 gap-12">
        {/* Section-02: Left Column: Headline and Location Menu */}
        <div className="pt-30 lg:col-span-1 text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-8 font-poppins leading-tight">
            Let's connect
          </h1>
          <nav className="space-y-4">
            {locations.map((location) => (
              <button
                key={location.id}
                onClick={() => setActiveLocation(location.id)}
                className={`flex items-center justify-between w-full py-3 px-4 rounded-lg text-lg font-semibold transition-colors duration-300
                  ${activeLocation === location.id ? 'bg-[#ECEE07] text-[#364A9A]' : 'hover:bg-white hover:bg-opacity-10'}`}
              >
                <span>{location.name}</span>
                <ChevronRight size={24} />
              </button>
            ))}
          </nav>
        </div>

        {/* Right Column: Contact Details and Map */}
        <div className="lg:col-span-2 text-white pb-20">
          <h2 className="text-3xl font-bold mb-4 font-poppins">
            {currentDetails.title}
          </h2>
          <div className="w-24 h-1 bg-[#ECEE07] mb-8"></div> {/* Separator */}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {/* Address & Email */}
            <div>
              <p className="text-lg font-semibold mb-2 font-poppins">Head Office</p>
              <div className="flex items-start mb-2">
                <MapPin size={20} className="mr-2 mt-1 flex-shrink-0" />
                <p className="font-serif">{currentDetails.address}</p>
              </div>
              <div className="flex items-center mb-2">
                <Mail size={20} className="mr-2" />
                <p className="font-serif">{currentDetails.email}</p>
              </div>
            </div>

            {/* Phone Numbers */}
            <div>
              <p className="text-lg font-semibold mb-2 font-poppins">Call Us</p>
              <div className="flex items-center mb-2">
                <Phone size={20} className="mr-2" />
                <p className="font-serif">{currentDetails.phone1}</p>
              </div>
              {currentDetails.phone2 && (
                <div className="flex items-center mb-2">
                  <Phone size={20} className="mr-2" />
                  <p className="font-serif">{currentDetails.phone2}</p>
                </div>
              )}
              {currentDetails.phone3 && (
                <div className="flex items-center mb-2">
                  <Phone size={20} className="mr-2" />
                  <p className="font-serif">{currentDetails.phone3}</p>
                </div>
              )}
            </div>
          </div>

          {/* Embedded Map */}
          <div className="rounded-lg overflow-hidden shadow-lg">
            <iframe
              src={currentDetails.mapEmbedUrl}
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map Location"
            ></iframe>
          </div>
        </div>
      </div>


    
     {/* Section-03: Social CTA Banner */}
          <SocialMediaCTA className="my-12" />
           <NewsSection className="my-12" />
                     
               </div>
             );
           };
           
           export default ContactUsPage;